import { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

export default function CartDiscountManager() {
  const [discounts, setDiscounts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [amount, setAmount] = useState("");
  const [percent, setPercent] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchDiscounts();
  }, []);

  const fetchDiscounts = async () => {
    const snapshot = await getDocs(collection(db, "cartdiscount"));
    const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setDiscounts(list);
  };

  const clearForm = () => {
    setEditingId(null);
    setAmount("");
    setPercent("");
    setStartDate("");
    setEndDate("");
  };

  const handleSubmit = async () => {
    if (!amount || !percent || !endDate) {
      alert("Вкажіть усі обов’язкові поля");
      return;
    }

    const discountData = {
      amount: Number(amount),
      percent: Number(percent),
      startDate: startDate ? new Date(startDate).toISOString() : null,
      endDate: new Date(endDate).toISOString(),
    };

    if (editingId) {
      const ref = doc(db, "cartdiscount", editingId);
      await updateDoc(ref, discountData);
      alert("Знижку оновлено");
    } else {
      await addDoc(collection(db, "cartdiscount"), discountData);
      alert("Знижку додано");
    }

    clearForm();
    fetchDiscounts();
  };

  const handleEdit = (d) => {
    setEditingId(d.id);
    setAmount(d.amount);
    setPercent(d.percent);
    setStartDate(d.startDate ? d.startDate.slice(0, 10) : "");
    setEndDate(d.endDate ? d.endDate.slice(0, 10) : "");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Видалити цю знижку?")) {
      await deleteDoc(doc(db, "cartdiscount", id));
      fetchDiscounts();
    }
  };

  return (
    <div style={styles.wrap}>
      <h2>Знижки від суми</h2>

      <div style={styles.list}>
        {discounts.map((d) => (
          <div key={d.id} style={styles.item}>
            <strong>{d.amount} грн</strong> — {d.percent}%
            <br />
            {d.startDate && (
              <span>
                з {new Date(d.startDate).toLocaleDateString()} по{" "}
                {new Date(d.endDate).toLocaleDateString()}
              </span>
            )}
            {!d.startDate && (
              <span>до {new Date(d.endDate).toLocaleDateString()}</span>
            )}
            <div>
              <button onClick={() => handleEdit(d)}>Редагувати</button>
              <button onClick={() => handleDelete(d.id)}>Видалити</button>{" "}
            </div>
          </div>
        ))}
      </div>

      <div style={styles.form}>
        <h3>{editingId ? "Редагувати" : "Додати"} знижку</h3>

        <input
          type="number"
          placeholder="Сума від (грн)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          style={styles.input}
        />

        <input
          type="number"
          placeholder="% Знижка"
          value={percent}
          onChange={(e) => setPercent(e.target.value)}
          style={styles.input}
        />

        <label>
          Дата старту (не обов’язково):
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={styles.input}
          />
        </label>

        <label>
          Дата завершення:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={styles.input}
          />
        </label>

        <button onClick={handleSubmit} style={styles.button}>
          {editingId ? "Зберегти зміни" : "Додати"}
        </button>

        {editingId && (
          <button onClick={clearForm} style={styles.buttonCancel}>
            Скасувати редагування
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    maxWidth: "700px",
    margin: "30px auto",
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
  },
  list: {
    marginBottom: "30px",
  },
  item: {
    padding: "10px",
    border: "1px solid #ddd",
    marginBottom: "10px",
  },
  form: {
    padding: "20px",
    background: "#f9f9f9",
    borderRadius: "6px",
  },
  input: {
    display: "block",
    margin: "10px 0",
    padding: "10px",
    width: "100%",
  },
  button: {
    padding: "10px 15px",
    cursor: "pointer",
    marginRight: "10px",
  },
  buttonCancel: {
    padding: "10px 15px",
    cursor: "pointer",
    background: "#eee",
  },
};
